<script>
export default {
  name: 'video-block',
  props: {
    src: String,
    serverPreview: String,
  },
  data() {
    return {
      isOpen: false,
      formatSrc: '',
      preview: '',
    }
  },
  mounted() {
    this.getVideo()
    if ('None' === this.serverPreview || !this.serverPreview) {
      this.preview = this.getVideoPreview(this.src)
    } else {
      this.preview = this.serverPreview
    }
  },
  methods: {
    openVideo() {
      this.isOpen = true
    },
    getVideoId(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
      const match = url.match(regExp)
      const eleven = 11
      if (match && match[2].length === eleven) {
        return match[2]
      }
      return 'error'
    },
    getVideo() {
      const item = `//www.youtube.com/embed/${this.getVideoId(this.src)}?autoplay=1`
      this.formatSrc = item
    },
    getVideoPreview(url) {
      const videoPreview = `//img.youtube.com/vi/${this.getVideoId(url)}/sddefault.jpg`
      return videoPreview
    },
  },
  render() {
    return this.$scopedSlots.default({
      open: this.openVideo,
      isOpen: this.isOpen,
      src: this.formatSrc,
      preview: this.preview,
    })
  },
}
</script>
